import { FormTemplate } from '@src/core';

const Collect1Form: FormTemplate = {
  title: 'Questionário Puérpera',
  subtitle: 'Questionário 1: alta hospitalar (24h a 48h pós-parto)',
  initialMessage:
    'Olá, tudo bem? <br/><br/> Primeiramente, obrigado por estar dedicando um tempo para nos ajudar com a pesquisa! <br/><br/>A seguir, faremos algumas perguntas sobre seu processo de recuperação neste período de <b>alta hospitalar</b>.Por favor, selecione as respostas que mais fielmente representam seu estado atual, especialmente em relação à recuperação na área com pontos onde você foi suturada.<br/><br/>Durante as questões, você notará que mencionaremos a palavra "DOR" algumas vezes. Sempre que isso ocorre, estamos nos referindo a qualquer tipo de desconforto ou sensação incômoda associada aos pontos no períneo/vagina.<br/><br/>Vamos lá?',
  endedMessage:
    'Muito obrigado por ter respondido nossa pesquisa do projeto XPTO! 🤩 <br/><br/>Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.',
  steps: [
    {
      title: 'Dados do Prontuário',
      questions: {
        hospitalRegister: {
          sequence: 3,
          type: 'text',
          fieldType: 'number',
          label: 'Registro Hospitalar',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        hospitalBed: {
          sequence: 4,
          type: 'text',
          fieldType: 'number',
          label: 'Número do Leito',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
      },
    },
    {
      title: 'Dados de Caracterização da Mulher',
      questions: {
        age: {
          sequence: 8,
          type: 'text',
          label: 'Idade',
          fieldType: 'number',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        education: {
          sequence: 9,
          layout: '1-column',
          type: 'radio',
          label: 'ESCOLARIDADE: Até que ano você estudou?',
          options: [
            'Não alfabetizada',
            'Fundamental I (1ª a 5ª série)',
            'Fundamental II (6ª a 9ª série)',
            'Médio (antigo 2ª grau)',
            'Superior',
          ],
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          requestDetail: {
            required: true,
            label: 'Detalhe, concluído até:',
            options: [
              'Não informado',
              {
                groupName: 'Fundamental I (1ª a 5ª série)',
                options: ['1ª série', '2ª série', '3ª série', '4ª série', '5ª série'],
              },
              {
                groupName: 'Fundamental II (6ª a 9ª série)',
                options: ['6ª série', '7ª série', '8ª série', '9ª série'],
              },
              { groupName: 'Médio (antigo 2ª grau)', options: ['1º ano', '2º ano', '3º ano'] },
              { groupName: 'Superior', options: ['Completo', 'Incompleto'] },
            ],
          },
        },
        maritalSituation: {
          sequence: 10,
          layout: '1-column',
          type: 'radio',
          label: 'SITUAÇÃO CONJUGAL?',
          options: ['Com companheiro', 'Sem companheiro'],
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
        },
      },
    },
    {
      title: 'Dados Obstétricos',
      questions: {
        question01: {
          sequence: 11,
          type: 'imc',
          label: '1. Índice de Massa Corporal pré-gestacional?',
          validator: {
            dataType: 'object',
            required: true,
          },
          fullWidth: true,
        },
        question05: {
          sequence: 15,
          type: 'radio',
          label: '5. Paridade?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Nulípara', 'Primípara', 'Multípara - partos anteriores'],
          requestDetails: [
            {
              id: 'VaginalBirth',
              label: 'Parto vaginal:',
              conditions: [{ condition: 'Multípara - partos anteriores' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
            {
              id: 'AssistedVaginalBirth',
              label: 'Parto vaginal assistido:',
              conditions: [{ condition: 'Multípara - partos anteriores' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
            {
              id: 'CesareanBirth',
              label: 'Parto cesárea:',
              conditions: [{ condition: 'Multípara - partos anteriores' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
            {
              id: 'Abortion',
              label: 'Aborto:',
              conditions: [{ condition: 'Multípara - partos anteriores' }, { condition: 'Nulípara' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
          ],
        },
        question06: {
          sequence: 18,
          type: 'checkbox',
          label: '6. Histórico de incontinência?',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: ['Fezes', 'Gases', 'Urina', 'Nenhum'],
        },
      },
    },
    {
      title: 'Dados do Parto Atual',
      questions: {
        question11: {
          sequence: 23,
          type: 'radio',
          label: '11. Presença de acompanhante?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Sim', 'Não'],
        },
        question17: {
          sequence: 29,
          type: 'radio',
          label: '17. Posição de parto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Banqueta', 'Cócoras', 'Em pé', 'Lateral', 'Quatro apoios', 'Semi-sentada', 'Outros'],
          requestDetail: {
            label: 'Para "Outros", especifique?',
            conditions: [{ condition: 'Outros' }],
          },
          isRequestDetailOther: true,
        },
        question18: {
          sequence: 30,
          type: 'radio',
          label: '19. Episiotomia médio lateral direita?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Sim', 'Não'],
        },
      },
    },
    {
      title: 'Dados do RN',
      questions: {
        gender: {
          sequence: 37,
          type: 'radio',
          label: 'Sexo?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['Masculino', 'Feminino'],
        },
        apgar1minute: {
          sequence: 38,
          type: 'select',
          options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          fieldType: 'number',
          label: 'APGAR 1 minuto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        apgar5minute: {
          sequence: 39,
          type: 'select',
          options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          label: 'APGAR 5 minutos?',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: false,
        },
        rnDestiny: {
          sequence: 43,
          type: 'radio',
          label: 'Destino do RN',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['AC', 'UTI', 'UCINCO'],
        },
      },
    },
  ],
};

export { Collect1Form };
